import React from 'react';

import { TClientsTableItem, TClientsTableSortableField } from 'types/state';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import {
  TableTr,
  TableWrapper,
  TableHead,
  TableTh,
  TableBody,
} from 'design/table';
import { ClientsTableItem } from 'containers/ClientsTable';

type Props = {
  items: TClientsTableItem[];
  sortedBy: TClientsTableSortableField;
  ascendingSort: boolean;
  activeItemId?: number;
  onSortChange(nextSortBy: TClientsTableSortableField): void;
  onItemClick(item: number): void;
};

export const ClientsTable = (props: Props) => {
  const {
    items,
    sortedBy,
    ascendingSort,
    activeItemId,
    onSortChange,
    onItemClick,
  } = props;

  const { clientsTableColumns: columnsIntl } = useIntlDictionary();

  // Обработчики нажатий по заголовкам таблицы.

  const onIdClick = React.useCallback(() => {
    onSortChange('id');
  }, [onSortChange]);
  const onCompanyClick = React.useCallback(() => {
    onSortChange('company');
  }, [onSortChange]);
  const onFullNameClick = React.useCallback(() => {
    onSortChange('fullName');
  }, [onSortChange]);
  const onPositionClick = React.useCallback(() => {
    onSortChange('position');
  }, [onSortChange]);
  const onStaffClick = React.useCallback(() => {
    onSortChange('orgStaffCount');
  }, [onSortChange]);
  // const onPhoneClick = React.useCallback(() => {
  //   onSortChange('phone');
  // }, [onSortChange]);
  const onEmailClick = React.useCallback(() => {
    onSortChange('email');
  }, [onSortChange]);
  const onProdStackClick = React.useCallback(() => {
    onSortChange('prodStack');
  }, [onSortChange]);
  const onDemoStackClick = React.useCallback(() => {
    onSortChange('demoStack');
  }, [onSortChange]);
  // const onRegisteredOnClick = React.useCallback(() => {
  //   onSortChange('registeredOn');
  // }, [onSortChange]);
  const onUpdatedOnClick = React.useCallback(() => {
    onSortChange('updatedOn');
  }, [onSortChange]);

  // Мемоизированные строки таблицы клиентов.
  const tableRowsNode = React.useMemo(() => {
    return items.map((item) => (
      <ClientsTableItem
        key={item.id}
        active={activeItemId === item.id}
        item={item}
        onClick={onItemClick}
      />
    ));
  }, [items, activeItemId, onItemClick]);

  return (
    <TableWrapper>
      <TableHead>
        <TableTr>
          <TableTh
            size="xs"
            sorted={sortedBy === 'id'}
            ascending={ascendingSort}
            text={columnsIntl.id}
            onClick={onIdClick}
          />
          <TableTh
            size="xxl"
            sorted={sortedBy === 'company'}
            ascending={ascendingSort}
            text={columnsIntl.company}
            onClick={onCompanyClick}
          />
          <TableTh
            size="xxl"
            sorted={sortedBy === 'fullName'}
            ascending={ascendingSort}
            text={columnsIntl.fullName}
            onClick={onFullNameClick}
          />
          <TableTh
            size="xl"
            sorted={sortedBy === 'email'}
            ascending={ascendingSort}
            text={columnsIntl.email}
            onClick={onEmailClick}
          />
          <TableTh
            size="xl"
            sorted={sortedBy === 'position'}
            ascending={ascendingSort}
            text={columnsIntl.position}
            onClick={onPositionClick}
          />
          <TableTh
            size="m"
            sorted={sortedBy === 'orgStaffCount'}
            ascending={ascendingSort}
            text={columnsIntl.staff}
            onClick={onStaffClick}
          />
          <TableTh size="m" text={columnsIntl.balance} />
          <TableTh
            size="l"
            sorted={sortedBy === 'prodStack'}
            ascending={ascendingSort}
            text={columnsIntl.prodStack}
            onClick={onProdStackClick}
          />
          <TableTh
            size="l"
            sorted={sortedBy === 'demoStack'}
            ascending={ascendingSort}
            text={columnsIntl.demoStack}
            onClick={onDemoStackClick}
          />
          {/* <TableTh sorted={sortedBy === 'registeredOn'} ascending={ascendingSort} text={columnsIntl.registeredOn} onClick={onRegisteredOnClick} /> */}
          <TableTh
            size="s"
            sorted={sortedBy === 'updatedOn'}
            ascending={ascendingSort}
            text={columnsIntl.updatedOn}
            onClick={onUpdatedOnClick}
          />
        </TableTr>
      </TableHead>
      <TableBody>{tableRowsNode}</TableBody>
    </TableWrapper>
  );
};
